import { render, staticRenderFns } from "./Communique.vue?vue&type=template&id=580f7a23&scoped=true&"
import script from "./Communique.vue?vue&type=script&lang=js&"
export * from "./Communique.vue?vue&type=script&lang=js&"
import style0 from "./Communique.vue?vue&type=style&index=0&id=580f7a23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580f7a23",
  null
  
)

export default component.exports